import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTypedSelector } from '@hooks/useTypedSelector';
import { useWatch } from 'react-hook-form';
import { FormulaManager } from '@utils/managers/FormulaManager';
import { handlerFieldWatch } from '@utils/fieldWatchUtils';
import { IDocumentTab } from '../DocumentTabLabel/DocumentTabLabel';

export interface IDocumentTabContent {
    tab: IDocumentTab;
}

const DocumentTabContent: FC<IDocumentTabContent> = ({ tab }: IDocumentTabContent) => {
    const document = useTypedSelector((state) => state.document);

    const visibilityRules = tab?.visibilityRules;
    const visibilityMng = useMemo(() => {
        const manager = new FormulaManager(visibilityRules!);
        manager.Init(tab.fields);
        return manager;
    }, [visibilityRules, tab.fields]);

    const activated = React.useRef(false);
    const [visibility, setVisibility] = useState<boolean>(false);
    const InitFormulas = async () => {
        let result = await visibilityMng.EvalFormulaValues(document.isEdit, document.isNew);
        if (activated.current) {
            setVisibility(result);
        }
    };
    useEffect(() => {
        activated.current = true;
        InitFormulas();
        return () => {
            activated.current = false;
        };
    }, []);
    const watchVisibility = useWatch({
        name: visibilityMng.GetWatchFields(),
    });

    useEffect(() => {
        handlerFieldWatch(watchVisibility, document.isEdit, document.isNew, visibilityMng, setVisibility, activated);
    }, [watchVisibility, document.isEdit, document.isNew]);

    return visibility ? <>{tab.tab}</> : <></>;
};

export default DocumentTabContent;
